import isEmpty from "lodash/isEmpty";
import styles from "./DeviceList.module.scss";
import classNames from "classnames";
import { Device } from "../types";

type DeviceListParams = {
  searchResult: Array<Device>;
  onSelect: (deviceId: string) => void;
  showResultInfo?: boolean;
  totalResults: number;
};

const DeviceList = ({
  searchResult,
  onSelect,
  showResultInfo,
  totalResults,
}: DeviceListParams) => {
  if (isEmpty(searchResult)) return null;

  const handleSelectOnKeyDown = (e: { keyCode: number }, deviceId: string) => {
    if (e.keyCode === 13) handleSelect(deviceId);
  };

  const handleSelect = (deviceId: string) => {
    onSelect(deviceId);
  };

  const formatResultInfo = () => {
    const fewResults = `${totalResults} ${
      totalResults === 1 ? "result." : "results."
    }`;
    const manyResults = (
      <>
        <span>
          Showing {searchResult.length} / {totalResults} results. Keep typing to
          refine your search.
        </span>
      </>
    );

    return searchResult.length === totalResults ? fewResults : manyResults;
  };

  return (
    <div
      className={classNames(
        styles.deviceList,
        showResultInfo && styles["deviceList--showInfo"],
      )}
      data-cy="search-devices-list"
    >
      {showResultInfo && (
        <span className={styles.deviceList__resultInfo}>
          {formatResultInfo()}
        </span>
      )}
      <ul>
        {searchResult?.map(({ deviceId, description }, index) => (
          <li
            tabIndex={0}
            key={`list-${index}`}
            onClick={() => handleSelect(deviceId)}
            onKeyDown={(e) => handleSelectOnKeyDown(e, deviceId)}
          >
            {description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeviceList;
